/**
 * Application route path constants
 * 
 * This file contains all route paths used in the application.
 */

export const APP_PATHS = {
    // Dashboard
    DASHBOARD: '/dashboard',
    
    // Returns Management
    CREATE_RMA: '/create-rma',
    RETURNS: '/manage-returns/rma-list-page',
    RETURNS_RMA_ID: '/manage-returns/rma-list-page/:rmaId',
    RETURNS_NEW: '/manage-returns-new/rma-list-page',
    RETURNS_NEW_RMA_ID: '/manage-returns-new/rma-list-page/:rmaId',
    
    // Return Reasons
    RETURN_REASONS: '/return-reasons',
    RETURN_REASONS_REASON_ID: '/return-reasons/:reasonId',
    RETURN_REASONS_FOLLOW_UP: '/return-reasons/:reasonId/:fuqId',
    
    // Email Settings
    EMAIL_BASE: '/email',
    EMAIL_VARIABLES_AND_EVENTS: '/email/variables-and-events',
    EMAIL_CONTENT: '/email/content',
    EMAIL_CONTENT_EVENT_ID: '/email/content/:eventId',
    EMAIL_CHARGED_FEES_INVOICE_TRANSLATIONS: '/email/content/charged-fees-invoice-email-translations',
    EMAIL_EXCHANGE_ORDER_INVOICE_TRANSLATIONS: '/email/content/exchange-order-invoice-translations',
    EMAIL_NOTIFICATIONS: '/email/notifications',
    EMAIL_LOOK_AND_FEEL: '/email/look-and-feel',
    
    // Subscription & Billing
    SUBSCRIPTION_PLANS: '/subscription-plans',
    BILLING: '/billing',

    PROFILE: '/profile',
    
    // Admin Routes
    ADMIN_MANAGE_PLANS: '/admin/manage-plans',
    ADMIN_MANAGE_PLANS_ID: '/admin/manage-plans/:id',
    ADMIN_MANAGE_PLANS_TYPE_ID: '/admin/manage-plans/:type/:id',
    ADMIN_MANAGE_MERCHANTS_PLANS: '/admin/manage-merchants-plans',
    ADMIN_MIGRATE_GLOBAL_E_MERCHANTS: '/admin/migrate-global-e-merchants',
    ADMIN_ACCOUNTS: '/admin/accounts',
    ADMIN_ACCOUNTS_ID: '/admin/accounts/:id',
    ADMIN_DEV_SETTINGS: '/admin/dev-settings',
    ADMIN_TROUBLESHOOTING: '/admin/troubleshooting',
    ADMIN_ACCOUNT_HEALTH: '/admin/account-health',
    
    // Analytics
    ANALYTICS_RETURNS: '/analytics-returns',
    ANALYTICS_ORDERS: '/analytics-orders',
    ANALYTICS_SESSIONS: '/analytics-sessions',
    ANALYTICS_CREDITS: '/analytics/credits',
    ANALYTICS_TRANSACTIONS: '/analytics/transactions',
    ANALYTICS_SHIPMENTS: '/analytics/shipments',
    
    // Integrations
    INTEGRATIONS_BASE: '/integrations',
    INTEGRATIONS_PRODUCTS_SERVICES: '/integrations/products-services',
    INTEGRATIONS_API: '/integrations/api',
    INTEGRATIONS_API_ID: '/integrations/api/:id',
    
    // Widgets
    WIDGETS_REPORT_SHIPMENT: '/widgets/report/shipment',
    WIDGETS_REPORT_BILLING: '/widgets/report/billing',
    WIDGETS_REPORT_RETURNS: '/widgets/report/returns',
    WIDGETS_REPORT_TRACKING: '/widgets/report/tracking',
    
    // Settings - General
    SETTINGS_BASE: '/settings',
    SETTINGS_GENERAL: '/settings/store',
    SETTINGS_LANGUAGES: '/settings/portal-and-emails-languages',
    
    // Settings - Portal Content
    SETTINGS_PORTAL_CONTENT: '/settings/portals/content',
    SETTINGS_PORTAL_CONTENT_LOCATE_ORDER: '/settings/portals/content/locate-order',
    SETTINGS_PORTAL_CONTENT_SELECT_ITEMS: '/settings/portals/content/select-items',
    SETTINGS_PORTAL_CONTENT_POLICY_CONFIRMATION: '/settings/portals/content/policy-confirmation',
    SETTINGS_PORTAL_CONTENT_PRODUCT_EXCHANGE: '/settings/portals/content/product-exchange',
    SETTINGS_PORTAL_CONTENT_GIFT_RETURNS: '/settings/portals/content/gift-returns',
    SETTINGS_PORTAL_CONTENT_LOCATE_SHIPMENT: '/settings/portals/content/locate-shipment',
    SETTINGS_PORTAL_CONTENT_TRACKING_STATUSES: '/settings/portals/content/tracking-statuses',
    SETTINGS_PORTAL_CONTENT_GENERAL_TEXTS: '/settings/portals/content/general-texts',
    SETTINGS_PORTAL_CONTENT_WARNINGS_AND_MESSAGES: '/settings/portals/content/warnings-and-messages',
    SETTINGS_PORTAL_CONTENT_REFUND_METHODS: '/settings/portals/content/refund-methods',
    
    // Settings - Resolutions
    RESOLUTIONS: '/resolutions',
    RESOLUTIONS_RESOLUTION_ID: '/resolutions/:resolutionId',
    
    // Settings - Return Methods
    RETURN_METHODS: '/return-methods',
    RETURN_METHODS_RETURN_METHOD_ID: '/return-methods/:returnMethodId',
    RETURN_METHODS_ADDRESS_SLIP_TRANSLATIONS: '/return-methods/locale-address-slip-fields-translate',
    RETURN_METHODS_PACKING_SLIP_TRANSLATIONS: '/return-methods/locale-packing-slip-fields-translate',
    
    // Settings - Return Policies
    POLICY_RULES: '/policy-rules',
    POLICY_RULES_POLICY_ID: '/policy-rules/:policyId',
    
    // Settings - Portal Look and Feel
    LOOK_AND_FEEL: '/look-and-feel',
    LOOK_AND_FEEL_GENERAL_SETTINGS: '/look-and-feel/general-settings',
    LOOK_AND_FEEL_RETURN_PORTAL: '/look-and-feel/return-portal',
    LOOK_AND_FEEL_TRACKING_PORTAL: '/look-and-feel/tracking-portal',
    
    // Return Coverage
    RETURN_COVERAGE: '/return-guard',
    RETURN_COVERAGE_ENABLED: '/return-guard/coverage-settings-enabled',
    
    // Ship by ReturnGO
    SHIP_BY_RETURNGO: '/ship-by-returngo',

    // Localization pages
    STOREFRONT_LOCALIZATION: '/settings/localization/store-front',
    RETURN_PORTAL_LOCALIZATION: '/settings/localization/return-portal',
    RETURN_METHODS_LOCALIZATION: '/settings/localization/return-methods',
    EMAILS_LOCALIZATION: '/settings/localization/email',
    TRACKING_EMAILS_LOCALIZATION: '/settings/localization/tracking-emails',
    
    // Other Routes
    USER_MASTER_LIST: '/user-master-list',
    RICH_EDITOR: '/rich-editor',
    CHOOSE_STORE_LOCATION: '/choose-store-location',
    SECRET_POPUP_PATH: '/secret-popup-path',
    EXAMPLES_CHECKBOXES_TREE_DROPDOWN: '/examples/checkboxes-tree-dropdown',
    ONBOARDING: '/onboarding',
} as const;

export type AppPath = typeof APP_PATHS[keyof typeof APP_PATHS];

